import React, { useState } from 'react';
import { ChevronRight, Search } from 'lucide-react';

import "../../../../assets/css/customer/subscreens/category/CategoryPage.css";
const CategorySidebar = ({
  searchQuery,
  setSearchQuery,
  categories,
  selectedCategory,
  setSelectedCategory,
  brands,
  selectedBrands,
  toggleBrand,
  selectedSubcategory,  
  setSelectedSubcategory, 
  tags,
  selectedTags,
  toggleTag,
  priceRange,
  setPriceRange,
}) => {
  // ✅ Track which category is expanded
  const [expandedCategory, setExpandedCategory] = useState(null);

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
    setSelectedSubcategory(null);
    // Toggle: agar already open hai toh band karo, warna open karo
    setExpandedCategory(prev => prev === categoryName ? null : categoryName);
  };

  return (
    <aside className="category-sidebar">

      {/* Search */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search products..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <Search size={18} />
      </div>

      {/* Categories */}
      <div className="filter-section">
        <h3 className="filter-title">Categories</h3>
        <ul className="category-list">

          <li>
            <div
              className={`category-item ${selectedCategory === 'All Products' ? 'active' : ''}`}
              onClick={() => {
                setSelectedCategory('All Products');
                setSelectedSubcategory(null);
                setExpandedCategory(null); // ✅ sab band karo
              }}
            >
              <span>All Products</span>
              <ChevronRight size={16} />
            </div>
          </li>

          {categories.map((category) => (
            <li key={category.id}>
              <div
                className={`category-item ${selectedCategory === category.category_name ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category.category_name)}
              >
                <span>{category.category_name}</span>
                {/* ✅ Arrow rotate ho jab expanded ho */}
                <ChevronRight
                  size={16}
                  style={{
                    transform: expandedCategory === category.category_name ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }}
                />
              </div>

              {/* ✅ Sirf tab show karo jab yeh category expanded ho */}
              {expandedCategory === category.category_name &&
                category.subcategories &&
                category.subcategories.length > 0 && (
                <ul className="subcategory-list">
                  {category.subcategories.map((sub) => (
                    <li key={sub.id}>
                      <div
                        className={`subcategory-item ${
                          selectedSubcategory === sub.subcategoryname ? 'active' : ''
                        }`}
                        onClick={(e) => {
                          e.stopPropagation(); // parent click se bachao
                          setSelectedSubcategory(sub.subcategoryname);
                        }}
                      >
                        {sub.subcategoryname}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    

    </aside>
  );
};

export default CategorySidebar;